import React from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { getLoadingQuerySteps, getLoadingRowsRequest } from '@/store-selectors';
import {
  DataPresentationConfigurationSidebar,
  LoadingSpinner,
  QueryStepsSidebar,
} from './subcomponents';
import { useQueryBuilderStepsFlow } from './hooks';
import { QueryBuilderContainer } from './QueryBuilder.styles';
import { ProgressChecklist } from './subcomponents/ProgressChecklist';

const getIsLoading = createSelector(
  getLoadingRowsRequest,
  getLoadingQuerySteps,
  (isQueryLoading, areQueryStepsLoading) =>
    isQueryLoading || areQueryStepsLoading,
);

export const QueryBuilder = () => {
  useQueryBuilderStepsFlow();
  const isLoading = useSelector(getIsLoading);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <QueryBuilderContainer>
      <QueryStepsSidebar />
      <Outlet />
      <DataPresentationConfigurationSidebar />
      <ProgressChecklist />
    </QueryBuilderContainer>
  );
};

export default QueryBuilder;
